import { Fragment, FunctionComponent, useRef } from "react";
import { Table } from "@pjs/core-ui";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { focusFirstInteractiveOrFallback } from "../../account-settings/functions/FocusFirstInteractiveOrFallback.function";
import { launchConfirmRevokeDeviceDialog } from "./functions/LaunchConfirmRevokeDeviceDialog.function";
import { AuthorisedDeviceRow } from "./AuthorisedDevicesRow.component";
import { IAuthorisedDevicesProps } from "./interfaces/IAuthorisedDevicesProps";
import "./styles/authorised-devices.css";

export const AuthorisedDevices: FunctionComponent<IAuthorisedDevicesProps> = (props) => {
    const titleRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    const descriptionText =
        props.model.devices.length > 0
            ? userUiI18n.getPluralString("external_services.authorised_devices.with_devices", { count: props.model.devices.length })
            : userUiI18n.getString("external_services.authorised_devices.no_devices");

    return (
        <Fragment>
            <h3 className="uui-authorised-devices__title" tabIndex={-1} ref={titleRef}>
                {userUiI18n.getString("external_services.authorised_devices.title")}
            </h3>

            <p className="uui-authorised-devices__description">{descriptionText}</p>

            {props.model.devices.length > 0 && (
                <div className="uui-authorised-devices__table-wrapper" ref={contentRef}>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell>{userUiI18n.getString("external_services.authorised_devices.table_headers.name")}</Table.HeaderCell>
                            <Table.HeaderCell>{userUiI18n.getString("external_services.authorised_devices.table_headers.device")}</Table.HeaderCell>
                            <Table.HeaderCell />
                        </Table.Header>
                        <Table.Body>
                            {props.model.devices.map((device) => {
                                return (
                                    <AuthorisedDeviceRow
                                        key={device.tokenId}
                                        device={device}
                                        onUnmountWithFocus={(currentEl: HTMLElement) =>
                                            focusFirstInteractiveOrFallback(contentRef.current, () => titleRef.current?.focus(), [currentEl])
                                        }
                                        revokeAccess={(revokeButton: HTMLElement, resetIsRevoking: () => void) =>
                                            launchConfirmRevokeDeviceDialog(
                                                device,
                                                props.actions.revokeDeviceAccess,
                                                revokeButton,
                                                () => focusFirstInteractiveOrFallback(contentRef.current, () => titleRef.current?.focus()),
                                                resetIsRevoking
                                            )
                                        }
                                    />
                                );
                            })}
                        </Table.Body>
                    </Table>
                </div>
            )}
        </Fragment>
    );
};
